<template>
  <div class="container">
    <h1>Table {{tableNumber}} - Score du match</h1>

    <div class="card">
        <div class="matchTitle">
          <div class="center-align">
                <p
                  v-for="player in match.leftPlayers"
                  v-bind:key="player.id"
                >{{player.firstname}} {{player.name}}</p>
              </div>
              <div class="center-align">
                <p>vs</p>
              </div>
              <div class="center-align">
                <p
                  v-for="player in match.rightPlayers"
                  v-bind:key="player.id"
                >{{player.firstname}} {{player.name}}</p>
              </div>          
        </div>

        <div class="setContainer">
          <div class="center-align">
              <p><input v-model="set1.leftResult" type="number" /></p>
            </div>
            <div class="center-align">
              <p>Set 1</p>
            </div>
            <div class="center-align">
              <p><input v-model="set1.rightResult" type="number"/></p>
            </div>
        </div>

        <div class="setContainer">
          <div class="center-align">
              <p><input v-model="set2.leftResult" type="number" /></p>
            </div>
            <div class="center-align">
              <p>Set 2</p>
            </div>
            <div class="center-align">
              <p><input v-model="set2.rightResult" type="number"/></p>
            </div>
        </div>
    </div>

    <div class="buttonBar">
      <a class="button" v-on:click="updateScore()">
        <i class="material-icons right">save</i>Enregistrer
      </a>
    </div>
  </div>  
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import scoreService from '@/services/ScoreService'

export default {
  name: "tables",
  data: function() {
    return {
      set1: {},
      set2: {},
      match: {},
      tableNumber: 0
    };
  },
  computed: {
    tables() {
      return this.$store.state.tables;
    }
  },
  watch: {
    '$route.params.id' : function(newId, oldId){
      if (this.$store.state.tables.length !== 0){
          const currentMatch = this.$store.state.tables.filter(table => table.number === Number(newId))[0].currentMatch;
          this.updateViewModel(currentMatch);
      }
    },
    tables : function(newTables, oldTables){
      var currentMatch = newTables.filter(table => table.number === Number(this.$route.params.id))[0].currentMatch;
      if (currentMatch.id !== this.match.id){
          this.updateViewModel(currentMatch);
      }
    }
  },
  components: {
  },
  mounted() {
    if (this.$store.state.tables !== 0){
      var currentMatch = this.$store.state.tables.filter(table => table.number === Number(this.$route.params.id))[0].currentMatch;
      this.updateViewModel(currentMatch);
    }
  },
  methods: {
    updateScore(){
      var score = scoreService.calculateScoreFromSets(this.set1, this.set2);
      axios.post("/tables/" + this.$route.params.id, score)
      .then(response => {
        this.$snack.success('Score enregistré. Passage au match suivant.')
        // normalement, le viewModel se met à jour tout seul via le websocket
        //this.updateViewModel(response.data.currentMatch);
      });
    },
    updateViewModel(match){
      this.tableNumber = this.$route.params.id;
      this.match = match;
      var score = match.score;
        if (score && score.sets && score.sets.length === 2){
          this.set1 = score.sets[0];
          this.set2 = score.sets[1];
        }
        else{
          this.set1 = {
            leftResult: "",
            rightResult: ""
          };
          this.set2 = {
            leftResult: "",
            rightResult: ""
          };
        }
    }
  }
};
</script>

<style scoped>
.container{
  width: 90%;
  margin: auto;
}
.card{
  box-shadow: 0.1em 0.2em 0.4em #ddd;
}
.matchTitle{
  display: grid;
  grid-template-columns: 4fr 1fr 4fr;
  background-color: #f1f1f1;
  font-weight: bold;
}
.center-align{
  text-align: center;
}
.setContainer{
  display: grid;
  grid-template-columns: 4fr 1fr 4fr;
  padding-top: 30px;
  padding-bottom: 30px;
}
input{
  width: 80px;
  padding: 6px 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: inset 0 1px 3px #ddd;
  font-size: 1.5em;
}
.buttonBar{
  margin-bottom: 20px;
}
</style>